import { toKebab } from './objects'

export const createPdfPage = ({ injectedCss, element }) => {
  const container = document.createElement('div')

  const html = document.createElement('html')
  const head = document.createElement('head')
  const style = document.createElement('style')

  const styles = Array.isArray(injectedCss) ? injectedCss : [injectedCss]

  style.textContent = styles.join('\n')

  const body = document.createElement('body')

  head.appendChild(style)
  html.appendChild(head)

  body.appendChild(element)

  html.appendChild(body)

  container.appendChild(html)

  return container.innerHTML
}
export const toStyleString = (props) => {
  return Object.entries(props || {}).map(([key, val]) => `${toKebab(key)}: ${val}`).join(';')
}
